module.exports = __webpack_public_path__ + "static/blockchain-min-746cccd48243184339574011003d97c3.png";